module.exports = __webpack_public_path__ + "static/media/Connect.9f67fe78.svg";